import {Action} from "@ngrx/store";
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES: string = '[ecommerce performance report net sales] Load Ecommerce Performance report net sales';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_SUCCESS: string = '[ecommerce performance report net sales] Load Ecommerce Performance report net sales Success';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_FAIL: string = '[ecommerce performance report net sales] Load Ecommerce Performance report net sales Fail';

export class LoadEcommercePerformanceReportNetSales implements Action {
  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommercePerformanceReportNetSalesSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_SUCCESS;

  constructor(public payload: {
    netSalesData: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePerformanceReportNetSalesFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_FAIL;

  constructor(public payload: any) {
  }

}


export type EcommercePerformanceReportNetSalesAction = LoadEcommercePerformanceReportNetSales | LoadEcommercePerformanceReportNetSalesSuccess | LoadEcommercePerformanceReportNetSalesFail;
